import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './style.scss'

export default class CloseButton extends Component {
    static propTypes = {
        onClick: PropTypes.func,
        pad: PropTypes.number,
        size: PropTypes.number,
    }

    static defaultProps = {
        onClick: () => {},
        pad: 5,
        size: 20,
    }

    onClickHandler = (_e) => {
        const { onClick } = this.props

        _e.preventDefault()
        _e.stopPropagation()

        onClick()
    }

    render() {
        const { pad, size } = this.props

        const length = size - pad

        return (
            <div className={'close-button'} onClick={this.onClickHandler}>
                <svg style={{ width: size, height: size }}>
                    <path d={`M${pad} ${pad} L${length} ${length} M${length} ${pad} L${pad} ${length}`} />
                </svg>
            </div>
        )
    }
}
